import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b1dc01b&scoped=true&lang=html&"
import script from "./customSingularStoreList.js?vue&type=script&lang=js&"
export * from "./customSingularStoreList.js?vue&type=script&lang=js&"
import style0 from "./customSingularStoreList.styl?vue&type=style&index=0&id=6b1dc01b&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1dc01b",
  null
  
)

export default component.exports